import { FC, memo } from 'react'

import { ContentProps } from './ContentProps'

import * as SC from './styles'

export const Content: FC<ContentProps> = memo(({ children }) => <SC.Box id="orbit-page">{children}</SC.Box>)
